import { OnInit, OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { Component, Input, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { FormGroup } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { SelectOptionSetComponent } from 'app/shared/dialogs/select-option-set-dialog/select-option-set-dialog.component';


/*
        unselectedListText: '@',
        listData: '<',
        onSelectionChanging: '&',
        form: '<',
        formFieldName: '@',
        selectionInvalidFunction: '&',
        isRequired: '<',
        selectListIsShown: '<',
        defaultIdSelected: '@'
*/
@Component({
    selector: 'gaweb-select-list',
    templateUrl: `./select-list.component.html`
})
export class SelectListComponent implements OnInit, OnChanges {
    @ViewChild('selectOption') public selectOptionSetComponent: SelectOptionSetComponent;
    private _form: FormGroup
    @Input() set form(f: FormGroup) {
        this._form = f;
        this.formChange.emit(f);
    }
    get form(): FormGroup {
        return this._form;
    }
    @Output() formChange = new EventEmitter();
    @Input() unselectedListText: string;
    @Input() listData: Array<SelectListDataItem>;
    //@Output() onSelectionChanging: ({ id }: { id: string }) => void;

    @Output() onSelectionInvalidFunction: EventEmitter<SelectListDataItem> = new EventEmitter();
    @Input() isRequired: boolean;
    @Input() selectListIsShown: boolean;
    @Input() defaultIdSelected: string;
    @Input() formIsSubmitted: boolean;
    selection: SelectListDataItem;
    listText: string;

    constructor() { }
    ngOnInit(): void {

        if (!this.selectListIsShown) {
            this.selectListIsShown = true;
        }

        this.selection = new SelectListDataItem('0', this.unselectedListText);
        this.listData.unshift(this.selection);

        if (!!this.defaultIdSelected) {
            this.selection = this.listData
                .filter((data) => { return data.id === this.defaultIdSelected })
                .shift();
        }

        this.listText = this.selection.description;

        if (!this.selectionInvalidFunction(this.selection)) {
            this.selectionInvalidFunction = () => {
                if (this.isRequired && this.selection.description === this.unselectedListText) {
                    return true;
                } else {
                    return false;
                }
            };
        }
    };
    selectionInvalidFunction(selection: SelectListDataItem) {
        if(this.onSelectionInvalidFunction != null) {
            this.onSelectionInvalidFunction.emit(selection);
            return true;
        } else {
            return false;
        }
    }
    ngOnChanges(changesObj: SimpleChanges): void {
        if (changesObj.selectListIsShown) {
            if (changesObj.selectListIsShown.isFirstChange()) return;
            const { currentValue } = changesObj.selectListIsShown;
            this.selectListIsShown = _.cloneDeep(currentValue);
            this.listText = this.unselectedListText;
        }
    }
    onSelectedItem({ id: id, desc: desc }) {
        this.selection = new SelectListDataItem(id, desc);
        this.listText = desc;
        this.form.patchValue({ 'country': id });
    }
    openSelectList = () => {
        this.selectOptionSetComponent.showModal();
    }
}
export class SelectListDataItem {
    constructor(public id: string, public description: string) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/select-list/select-list.component.ts